import React, { ChangeEvent, FC, useCallback } from "react";
import ButtonSmall from "../../F7/ButtonSmall";
import { Field } from "../FieldHandler";

const LinkField: FC<{
  field: Field & { type: "link" };
  onChange: (key: string, value: string | undefined) => void;
}> = (props) => {
  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const id = props.field.key;
      const value = e.target.value;
      props.onChange(id, value);
    },
    [props]
  );

  const handleOpenURLClick = useCallback(() => {
    if (props.field.value) {
      window.open(props.field.value, "_blank");
    }
  }, [props.field.value]);

  return (
    <span>
      <div
        style={{
          paddingRight: 40,
        }}
      >
        <input type="url" value={props.field.value || ""} placeholder={props.field.required ? "required" : ""} onChange={handleChange} />
      </div>
      <div
        style={{
          float: "right",
          marginTop: -37,
        }}
      >
        <ButtonSmall onClick={handleOpenURLClick}>
          <i
            className="fa fa-external-link"
            style={{
              color: "white",
            }}
          />
        </ButtonSmall>
      </div>
    </span>
  );
};

export default LinkField;
